// no deep linking, it's too expensive :/
const getAppDeepLink = () => `https://giphy.page.link/home`

export default getAppDeepLink
